import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const styles = {
  btnWrapper: {
    display: 'inline-block',
    float: 'right',
  },
  filterBtn: {
    borderRadius: '40px',
    color: '#979797',
    width: '104px',
    height: '2.625rem',
    fontFamily: 'Lato',
    fontSize: '1rem',
    border: 0,
    '&:focus': {
      boxShadow: 'none',
    },
  },
  txt: {
    color: '#979797',
    fontFamily: 'Lato',
    fontSize: '1rem',
    display: 'inline-block',
  },
  icon: {
    display: 'inline-block',
    float: 'left',
    composes: ['icon-filter'],
    '&:before': {
      lineHeight: '28px',
    },
  },
};

const FilterBtn = (props) => {
  const { classes } = props;
  return (
    <div className={classes.btnWrapper}>
      {/* <i className="icon-filter" />
      <div className={classes.txt}>Filter</div> */}
      <Button className={classes.filterBtn} outline color="secondary">
        <i className={classes.icon} />
        <span className={classes.text}> Filter </span>
      </Button>
    </div>
  );
};

FilterBtn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(FilterBtn);



// WEBPACK FOOTER //
// ./src/components/FilterBtn.js